<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'uuid',
            dictionary: null,
            initDictionary: [],
            dictionaries_options: []
        }
    },

    watch: {
        initDictionary: {
            immediate: true,
            handler(values) {
                this.dictionary = this.dictionaries_options.filter(x => values.includes(x[this.trackBy]));
                this.dictionary = this.dictionary[0];
            }
        },
        dictionary: {
            immediate: true,
            handler(values) {
                if(this.dictionary){
                    this.$parent.voicemail_detection_params.dictionary_uuid = this.dictionary.uuid ? this.dictionary.uuid : null
                } else {
                    this.$parent.voicemail_detection_params.dictionary_uuid = null
                }
            }
        }
    },

    computed: {
        dictionaries_list_data(){
            return this.$store.getters['dictionaries/GET_DICTIONARIES_LIST'];
        },
    },

    async mounted() {

        await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_LIST', {limit: 5000});

        this.dictionaries_options = this.dictionaries_list_data;

        if(this.$parent.params.voicemail_detection_params && this.$parent.params.voicemail_detection_params.dictionary_uuid) {
            this.initDictionary = [this.$parent.params.voicemail_detection_params.dictionary_uuid];
        }
    },

    methods: {

    }
}
</script>

<template>
    <div>

        <b-form-checkbox v-model="$parent.voicemail_detection_params.async_action" name="async_action" style="margin-top: 5px; margin-bottom: 10px" switch>
            Определять автоответчик / голосовую почту
        </b-form-checkbox>

        <b-form-group
            v-if="$parent.voicemail_detection_params.async_action"
            label="Словарь фраз автоответчика"
            label-for="dictionary"
        >
            <multiselect
                id="dictionary"
                v-model="dictionary"
                :options="dictionaries_options"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
                :track-by="trackBy"
            ></multiselect>
        </b-form-group>
        <b-form-group            
            label="Ожидать ответ, сек"
            label-for="timeout"
        >
            <b-form-input
                id="timeout"
                v-model="$parent.call.timeout"
            />
        </b-form-group>
    </div>
</template>
